module.exports = __webpack_public_path__ + "img/Group_27926.ed705a25.png";